import { ApiOptions } from '../../api-options.decorator';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseContract } from './base';

export class ApiContractLogistic extends ApiBaseContract {
  @ApiOptions({ channel: 'costGasTransportDistributionGet', interceptErrors: false })
  getGasTransportDistributionCost(gridOperator: string, meteringPoint: string, params: ParamsAdapter) {
    return this.get(`/logistics/cost/ngfr/transport_distrib/${gridOperator}/${meteringPoint}`, params);
  }

  @ApiOptions({ channel: 'costGasCtaGet', interceptErrors: false })
  getGasCtaCost(gridOperator: string, meteringPoint: string, params: ParamsAdapter) {
    return this.get(`/logistics/cost/ngfr/cta/${gridOperator}/${meteringPoint}`, params);
  }

  @ApiOptions({ interceptErrors: false })
  getModulation(gridOperator: string, meteringPoint: string, params: ParamsAdapter) {
    return this.get(`/logistics/cost/ngfr/modulation-coeffs/${gridOperator}/${meteringPoint}`, params);
  }

  @ApiOptions({ channel: 'logisticPutGasProfile', interceptErrors: false })
  putModulation(gridOperator: string, meteringPoint: string, params: ParamsAdapter) {
    return this.put(`/logistics/cost/ngfr/modulation-coeffs/${gridOperator}/${meteringPoint}`, params);
  }
}
